import { render, staticRenderFns } from "./InputContents.vue?vue&type=template&id=89f78aca&scoped=true&lang=pug&"
import script from "./InputContents.vue?vue&type=script&lang=js&"
export * from "./InputContents.vue?vue&type=script&lang=js&"
import style0 from "./InputContents.vue?vue&type=style&index=0&id=89f78aca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f78aca",
  null
  
)

/* custom blocks */
import block0 from "./InputContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports